function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
const baseUrl = '/integrations/slack';
class SlackHTTPClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getSlackAuthMeta", ()=>this.get('integration-providers/slack/meta')), _define_property(this, "disconnectSlackIntegration", (integrationId)=>this.delete(`${baseUrl}/${integrationId}`)), _define_property(this, "getSlackConfig", ()=>this.get(baseUrl)), _define_property(this, "updateSlackSettings", (integrationId, payload)=>this.put(`${baseUrl}/${integrationId}/settings`, payload)), _define_property(this, "getSlackChannels", (integrationId)=>this.get(`${baseUrl}/${integrationId}/api/channels`)), _define_property(this, "getSlackUsers", (integrationId)=>this.get(`${baseUrl}/${integrationId}/api/users`)), _define_property(this, "getNotificationsConfig", (integrationId)=>this.get(`${baseUrl}/${integrationId}/settings/notification-config`)), _define_property(this, "updateNotificationConfig", (integrationId, payload)=>this.post(`${baseUrl}/${integrationId}/settings/notification-config`, payload)), _define_property(this, "getProjectSlackSettings", (projectId)=>{
            return this.get(`${baseUrl}/settings/project/${projectId}`);
        }), _define_property(this, "updateProjectSlackSettings", (projectId, payload)=>{
            return this.put(`${baseUrl}/settings/project/${projectId}`, payload);
        });
    }
}
export const SlackApi = new SlackHTTPClient();
